import React from 'react';
import get from 'lodash/get';
import { useHistory } from 'react-router';
import { isAdmin, isSuperUser } from 'common/services/accounts.service';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import {
  changeUserTypeModalOptions,
  createConfirmModalOptions
} from 'modals/modal-options-factory';
import AppRouter from 'common/AppRouter';

const UseUserActionsData = ({
  myAccount,
  toggleSnackBar,
  resendInvitation,
  destroyInvitation,
  destroyAccount,
  toggleModal,
  changeUserAccountType,
  changeInvitationAccountType,
  ssoForceAndOk,
  account: {
    inviter_account_id,
    isPending,
    type_id,
    invitationId,
    invitee_name,
    name,
    id
  } = {}
}) => {
  const history = useHistory();
  const isCurrentUserAdmin = isAdmin(myAccount) || isSuperUser(myAccount);
  const displayName = invitee_name || name;
  const isInviter = inviter_account_id === myAccount.id;
  const canResend =
    (isInviter || isCurrentUserAdmin) && isPending && !ssoForceAndOk;
  const canEditPermissions = isCurrentUserAdmin || (isInviter && isPending);
  const canDelete =
    (isInviter && isPending) || (isCurrentUserAdmin && myAccount.id !== id);
  const _toggleSnackbar = ({ message, variant }) =>
    toggleSnackBar({
      message: (
        <Flex direction='column'>
          <Text size='large' color='white'>
            {message}
          </Text>
        </Flex>
      ),
      variant
    });

  const destroyRecord = () =>
    toggleModal(
      createConfirmModalOptions({
        title: 'Confirmation',
        description: `Are you sure you want to remove ${displayName}?`,
        confirmText: 'Yes, Delete',
        cancelText: 'Cancel',
        onConfirm: async () => {
          toggleModal();
          try {
            if (isPending) {
              await destroyInvitation(invitationId);
            } else {
              await destroyAccount(id);
            }
            _toggleSnackbar({
              message: `Deleted ${displayName} successfully`,
              variant: 'success'
            });
          } catch (e) {
            const errMsg = get(
              e,
              'response.data.description[0].msg',
              `Failed to delete`
            );
            _toggleSnackbar({ message: errMsg, variant: 'error' });
          }
        },
        onCancel: toggleModal
      })
    );

  const onResendInvitation = async () => {
    try {
      await resendInvitation(invitationId);
      _toggleSnackbar({
        message: 'Email sent successfully',
        variant: 'success'
      });
    } catch (e) {
      const errMsg = get(
        e,
        'response.data.description[0].msg',
        `Failed to Send`
      );
      _toggleSnackbar({ message: errMsg, variant: 'error' });
    }
  };

  const onAccountTypeChanged = async newAccountTypeId => {
    toggleModal();
    try {
      if (isPending) {
        await changeInvitationAccountType({
          id: invitationId,
          type_id: newAccountTypeId
        });
      } else {
        await changeUserAccountType({ id, type_id: newAccountTypeId });
      }
      _toggleSnackbar({
        variant: 'success',
        message: 'Account type was changed successfully'
      });
    } catch (exp) {
      _toggleSnackbar({
        variant: 'error',
        message: 'There was an issue changing account type'
      });
    }
  };
  const changeUserRole = () =>
    toggleModal(
      changeUserTypeModalOptions({
        toggleModal,
        myAccount,
        invitationId,
        accountId: id,
        typeId: type_id,
        displayName,
        onAccountTypeChanged
      })
    );
  const onEditPermissions = () =>
    history.push({
      pathname: `${AppRouter.USERS_PERMISSIONS_MULTIPLE.path}/${id}`,
      search: 'isOrgSettings=true'
    });
  return {
    canResend,
    canEditPermissions,
    canDelete,
    destroyRecord,
    onResendInvitation,
    changeUserRole,
    onEditPermissions
  };
};

export default UseUserActionsData;
